module.exports = __webpack_public_path__ + "img/check-mark-icon.02ca6f16.svg";